import { Transformer } from 'markmap-lib';
import * as markmap from 'markmap-view';
import { Panel } from './components/Panel';
const transformer = new Transformer();
const { Markmap, loadCSS, loadJS, deriveOptions } = markmap;

document.addEventListener( 'DOMContentLoaded', () => {
	const blocks = document.querySelectorAll( '.wp-block-wp-block-mindmap' );
	for ( const block of blocks ) {
		const svgEl = block.querySelector( 'svg' );
		const toolbarEl = block.querySelector(
			'.wp-block-mindmap-preview__toolbar'
		);
		try {
			const markdown = JSON.parse( block.dataset.markdown );
			const options = JSON.parse( block.dataset.options );
			const { root } = transformer.transform( markdown );
			const { styles, scripts } = transformer.getAssets();
			let markmapInstance = null;

			if ( styles ) loadCSS( styles );
			if ( scripts ) loadJS( scripts, { getMarkmap: () => markmap } );
			if ( svgEl ) {
				markmapInstance = Markmap.create(
					svgEl,
					deriveOptions( options ),
					root
				);
			}

			// Toobar is enable
			if ( toolbarEl ) {
				console.log( toolbarEl );
				toolbarEl
					.querySelector( '.zoom-in-handle' )
					.addEventListener( 'click', () => {
						markmapInstance.rescale( 1.25 );
					} );

				toolbarEl
					.querySelector( '.zoom-out-handle' )
					.addEventListener( 'click', () => {
						markmapInstance.rescale( 0.8 );
					} );

				toolbarEl
					.querySelector( '.fit-handle' )
					.addEventListener( 'click', () => {
						markmapInstance.fit();
					} );
			}
		} catch {
			throw new Error( 'Cannot parse markdown content & options' );
		}
	}
} );
